import { Card } from 'primereact/card';
import { FC } from 'react';
import SingleUnitCardData from './SingleUnitCardData';
import { CountPerTypes } from '../../models/SingleUnit';

interface Props {
  skillsTypesInUnit: CountPerTypes;
}

const SingleUnitLeftColumn: FC<Props> = ({ skillsTypesInUnit }) => {
  return (
    <div className="flex flex-column gap-md justify-content-start">
      <Card className="w-full nc_card" id="unitSkillCounts">
        <>
          <h1 className="text-center">{skillsTypesInUnit.targetName}</h1>
          <div className="flex flex-column gap-xl">
            {skillsTypesInUnit.types.map(value => {
              return <SingleUnitCardData key={value.targetSkillType} value={value} />;
            })}
          </div>
        </>
      </Card>
    </div>
  );
};

export default SingleUnitLeftColumn;
